<template>
  <!-- Retorno de 26/10 (card 17trt6jd8uu): campanha de Pitch Coins em andamento
       em destaque na página inicial, como o formulário pendente. Some quando
       não há campanha para este público; não bloqueia nada. -->
  <div v-if="items.length" class="acc-card" :style="{ borderColor: color }">
    <div class="acc-head">
      <v-icon size="22" :color="color">mdi-bullhorn-outline</v-icon>
      <div class="acc-title">
        {{ $tc("pitchCoins.homeCampaigns", items.length) }}
      </div>
    </div>

    <div class="acc-list">
      <div v-for="item in items" :key="item.id" class="acc-item">
        <div class="acc-item__main">
          <span class="acc-item__name">{{ item.name }}</span>
          <span v-if="item.description" class="acc-item__desc">
            {{ item.description }}
          </span>
          <span class="acc-item__meta">
            <strong>{{ campaignValue(item) }}</strong>
            ·
            {{ $t("pitchCoins.campaignUntil", { date: lastDay(item.endsAt) }) }}
          </span>
        </div>
      </div>
    </div>

    <v-btn
      depressed
      rounded
      small
      dark
      class="mt-3"
      :color="color"
      @click="open"
    >
      {{ $t("pitchCoins.homeSeeCoins") }}
    </v-btn>
  </div>
</template>

<script>
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import { classThemes } from "@/shared/classThemes";
import { formatCoinDate, formatCoins } from "@/shared/coins";

// Mesma fonte da página de Pitch Coins: a API já devolve só as campanhas em
// andamento para o público da pessoa. Falha de rede esconde o card, nunca a
// página inicial.
export default {
  name: "ActiveCampaignsCard",

  props: {
    profile: {
      type: String,
      default: "customer",
      validator: (value) => ["customer", "partner"].includes(value),
    },
  },

  data() {
    return { items: [] };
  },

  computed: {
    api() {
      return this.profile === "partner" ? pitchPartnerApi : pitchCustomerApi;
    },
    color() {
      return classThemes[this.profile]?.primary || "#A826E1";
    },
  },

  async mounted() {
    try {
      const res = await this.api.getCoinCampaigns();
      this.items = res?.data?.data || [];
    } catch (error) {
      this.items = [];
    }
  },

  methods: {
    lastDay(endsAt) {
      return formatCoinDate(new Date(new Date(endsAt).getTime() - 1), {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    // Pontuação fixa: quantos coins vale. Multiplicador: o fator e as ações.
    campaignValue(item) {
      if (item.kind === "multiplier") {
        return this.$t("pitchCoins.campaignMultiplier", {
          factor: formatCoins(item.value),
          rules: item.rules.join(", "),
        });
      }
      return this.$t("pitchCoins.campaignFixed", {
        amount: formatCoins(item.value),
      });
    },

    // Por caminho: o nome da rota do aluno e do professor se confundem.
    open() {
      const base =
        this.profile === "partner" ? "/connect/professor" : "/connect/aluno";
      this.$router.push(`${base}/pitch-coins`).catch(() => null);
    },
  },
};
</script>

<style scoped>
.acc-card {
  margin-bottom: 20px;
  padding: 18px 20px;
  border: 2px solid;
  border-radius: 16px;
  background: var(--dk-surface, #fff);
}

.acc-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.acc-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--dk-ink, #2b2540);
}

.acc-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.acc-item {
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--dk-ember-wash, #fff6db);
}

.acc-item__main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.acc-item__name {
  font-weight: 700;
  color: var(--dk-ink, #2b2540);
}

.acc-item__desc {
  color: var(--dk-muted, #6b6580);
  font-size: 0.875rem;
}

.acc-item__meta {
  color: var(--dk-ember-deep, #8a6500);
  font-size: 0.875rem;
}
</style>
